import { render } from "./EducationsStore.vue?vue&type=template&id=68cb0250&scoped=true"
import script from "./EducationsStore.vue?vue&type=script&lang=js"
export * from "./EducationsStore.vue?vue&type=script&lang=js"

import "./EducationsStore.vue?vue&type=style&index=0&id=68cb0250&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68cb0250"]])

export default __exports__